import TabPanel from 'client/components/GDS/Tabs/TabPanel/TabPanel';
import SelectFeatureAttributeTable from '../../SelectFeatureAttributeTable/SelectFeatureAttributeTable';
import PropTypes from 'prop-types';

export const TabDisplaySection = ({ label, sectionInformation, ...props }) => {
    return <TabPanel data-testid={props['data-testid']} label={label}>
        {sectionInformation && (
            <SelectFeatureAttributeTable
                data-testid={props['data-testid']}
                sectionProperties={sectionInformation}
            />
        )}
    </TabPanel>;
};

TabDisplaySection.propTypes = {
    'data-testid': PropTypes.string,
    label: PropTypes.string.isRequired,
    sectionInformation: PropTypes.array
};
